import {
  ColumnContainer,
  ColumnImageContainer,
  ColumnRedesSociais,
  FacebookIcon,
  FooterContainer,
  InstagramIcon,
  RedesSociais,
  YoutubeIcon
} from "./styles";

import bannerLojas from "../../assets/images/home/banners/bannerlojas-rodape.jpeg";

export const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <ColumnImageContainer>
        <img
          style={{ width: "100%", height: "100%" }}
          src={bannerLojas}
          alt="Lojas parceiras"
        />
      </ColumnImageContainer>

      <ColumnContainer>
        <h2>Contato</h2>
        <p>
          Rua Irmãos D'Angelo, 99, Sala 4
          Petrópolis/RJ
        </p>
        <p>(24)2237-0936</p>
      </ColumnContainer>

      <ColumnRedesSociais>
        <h2>Redes Sociais</h2>
        <RedesSociais>
          <a
            href="https://www.facebook.com/share/1CwpP6JEMt/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook do SISEP"
          >
            <FacebookIcon />
          </a>
          <a
            href="https://www.youtube.com/@SisepPetr%C3%B3polis"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube do SISEP"
          >
            <YoutubeIcon />
          </a>
          <a
            href="https://www.instagram.com/sisep_petropolis/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram do SISEP"
          >
            <InstagramIcon />
          </a>
        </RedesSociais>
      </ColumnRedesSociais>
    </FooterContainer>
  );
};
